

    <template>
	<div class="flex-1">
		<div class="flex space-x-5">
			<h4>Suggestion de mots-clés par IA</h4>
			<div class="tooltip-container">
				<span
					class="tooltip-icon"
					@mouseenter="showTooltip"
					@mouseleave="hideTooltip"
				>
					ℹ️
				</span>
				<div v-if="isTooltipVisible" class="tooltip-content">
					{{ prompt }}
				</div>
			</div>
		</div>
		<vs-textarea
			v-model="promptSuggestion"
			height="100px"
			placeholder="Saisissez le contexte en lien avec les de mots clés souhaités. Vous pouvez saisir une localisation, un secteur, un marché, un niveau de gamme… Vous pourrez modifier votre recherche si les résultats ne vous satisfont pas."
		/>
		<div v-if="runAiSuggestions">
			<div v-if="isOpenAiSuggestionLoading" class="mt-5">
				<circular-loader />
			</div>

			<div v-else>
				<div class="flex justify-end space-x-4 space-y-5">
					<vs-button
						v-if="!isOpenAiSuggestionLoading"
						@click="fetchOpenAiSuggestions"
						>Générer</vs-button
					>
				</div>
				<vs-table
					v-if="
						openAiKeywordIdeasObj.status_code == 200 &&
						Array.isArray(openAiKeywordIdeasObj.data)
					"
					:data="openAiKeywordIdeasObj.data"
					multiple
					search
					v-model="selectedKeywordsFromTable"
					pagination
					class="mt-5"
					max-items="100"
					noDataText="Aucun(e) mots-clés."
				>
					<template slot="header">Suggestion de mots-clés par IA </template>
					<template slot="thead">
						<vs-th style="pointer-events: auto" sort-key="keyword"
							>Mots-clés</vs-th
						>
						<vs-th style="pointer-events: auto" sort-key="cpc">Cpc</vs-th>
						<vs-th style="pointer-events: auto" sort-key="search_volume"
							>Search Volume</vs-th
						>
					</template>
					<template slot-scope="{ data }">
						<vs-tr
							:data="data[indextr]"
							:key="indextr"
							v-for="(tr, indextr) in data"
						>
							<vs-td :data="data[indextr].keyword">{{ tr.keyword }}</vs-td>
							<vs-td :data="data[indextr].cpc">{{
								tr.cpc && !isNaN(tr.cpc)
									? convertInternationalNumberToFrenchCurrency(tr.cpc)
									: tr.cpc
							}}</vs-td>
							<vs-td :data="data[indextr].search_volume">{{
								tr.search_volume && !isNaN(tr.search_volume)
									? tr.search_volume.toLocaleString("fr-FR")
									: tr.search_volume
							}}</vs-td>
						</vs-tr>
					</template>
				</vs-table>

				<vs-textarea
					class="mt-5"
					v-else
					v-model="openAiKeywordIdeasObj.data"
					:placeholder="
						'Vous avez sélectionné ' +
						selectedKeywordsFromTable.length +
						' mots-clés.'
					"
					readonly
				/>
			</div>
		</div>
	</div>
</template>

<script>
import CircularLoader from "../../../components/widgets/loader/CircularLoader.vue";
import ProspectSearch from "../../../entities/ProspectSearch";
import dbFieldConvertorMixin from "../../../mixins/dbFieldConvertorMixin";
import store from "@/store/store";

export default {
	components: { CircularLoader },
	name: "ProspectionSuggestionAIBox",
	props: {
		runAiSuggestions: {
			type: Boolean,
			default: false,
		},
		url: {
			type: String,
			default: "",
		},
	},
	mixins: [dbFieldConvertorMixin],
	data() {
		return {
			selectedKeywordsFromTable: [],
			promptSuggestion: "",
			openAiKeywordIdeasObj: {},
			isOpenAiSuggestionLoading: false,
			prompt: "",
			isTooltipVisible: false,
			tooltipText: "Suggestion de mots-clés par IA",
		};
	},
	watch: {
		selectedKeywordsFromTable(data) {
			this.$emit("click-choose-keyword", data);
		},
	},
	computed: {
		newProspects() {
			return store.state.newProspects;
		},
		// Your component's computed properties go here
		// newProspects() {
		// 	return store.state.newProspects;
		// },
	},
	created() {
		this.fetchOpenAiSuggestions();
		this.fetchPrompts();
	},
	updated() {},
	methods: {
		showTooltip() {
			this.isTooltipVisible = true;
		},
		hideTooltip() {
			this.isTooltipVisible = false;
		},
		async fetchPrompts() {
			try {
				const response = await ProspectSearch.getPrompts();
				this.prompt = response.prompt_1;
			} catch (e) {
				console.log("Error", e);
				this.$vs.notify({
					title: "Echec",
					color: "warning",
					text: "Erreur lors de la récupération des prompts de mots-clés du IA",
				});
			}
		},
		removeChooseKeyword(index) {
			this.selectedKeywordsFromTable.splice(index, 1);
		},
		async fetchOpenAiSuggestions() {
			try {
				this.isOpenAiSuggestionLoading = true;
				const body = {
					promptSuggestion: this.promptSuggestion,
					url: this.$props.url,
					language_name: this.newProspects.language_name,
					location_code: this.newProspects.location_code,
				};
				const response = await ProspectSearch.getOpenAiKeywordsIdeasByUrl(body);
				this.openAiKeywordIdeasObj = response;
				// Store the keyword list in the store
				this.$store.dispatch("setKeywordListByAi", response.data);
			} catch (e) {
				console.error(e);
				this.$vs.notify({
					title: "Echec",
					color: "danger",
					text: "Erreur lors de la récupération des suggestions de mots-clés par IA",
				});
			} finally {
				this.isOpenAiSuggestionLoading = false;
			}
		},
	},
};
</script>

<style scoped>
/* Toolt tip */
.tooltip-container {
	position: relative;
	display: inline-block;
	cursor: pointer;
}

.tooltip-icon {
	font-size: 16px;
}
.tooltip-content {
	position: absolute;
	top: 120%; /* Places tooltip at the bottom */
	width: 600px; /* Fixed width */
	left: 50%;
	transform: translateX(-50%);
	background-color: rgba(51, 51, 51, 1); /* Fully opaque background */
	color: #fff;
	padding: 8px 12px;
	border-radius: 5px;
	font-size: 14px;
	opacity: 0;
	z-index: 999;
	visibility: hidden;
	transition: opacity 0.3s ease-in-out;

	/* Text wrapping */
	white-space: normal;
	word-wrap: break-word;
	overflow-wrap: break-word;

	/* Optional: Add a more pronounced shadow */
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.5);
}
</style>